// Aperçu de fichiers dans l'outil (PDF, photos…), sans téléchargement.
//
// Une seule fenêtre pour toute l'application : ApercuFichier.vue, montée
// dans App.vue, écoute ce bus. Les composants comme les modules Vuex
// (qui n'ont pas accès à `this`) l'ouvrent avec ouvrirApercu().
//
//   ouvrirApercu({ nom: "Devis D-4.pdf", blob })          // réponse axios en blob
//   ouvrirApercu({ nom: "photo.jpg", url: img.path })     // fichier public
//   ouvrirApercu({ liste: [{ nom, url }, …], index: 2 })  // galerie (pochette)
//
// La fenêtre propose toujours « Télécharger » : l'aperçu remplace le
// téléchargement systématique, il ne l'interdit pas.
import Vue from "vue";

export const busApercu = new Vue();

export function ouvrirApercu(fichier) {
  busApercu.$emit("ouvrir", fichier);
}

const IMAGES = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];

export function extensionDe(nom) {
  const propre = String(nom || "").split("?")[0].split("#")[0];
  const point = propre.lastIndexOf(".");
  return point >= 0 ? propre.slice(point + 1).toLowerCase() : "";
}

/** "image", "pdf" ou "autre" (docx, xlsx… : pas d'aperçu fiable dans un navigateur). */
export function genreDe({ nom, type, url }) {
  const mime = String(type || "").toLowerCase();
  if (mime.indexOf("image/") === 0) return "image";
  if (mime === "application/pdf") return "pdf";
  const ext = extensionDe(nom) || extensionDe(url);
  if (IMAGES.indexOf(ext) >= 0) return "image";
  if (ext === "pdf") return "pdf";
  return "autre";
}
